import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useInjectReducer } from 'utils/redux-injectors';
import { reducer, sliceKey } from './slice';
import { selectFormError } from './selectors';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import ErrorIcon from '@mui/icons-material/Error';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import './styles/FormError.scss';

interface Props {
  children?: React.ReactNode;
}

export function FormError(props: Props) {
  const [open, setOpen] = useState(false);
  useInjectReducer({ key: sliceKey, reducer: reducer });

  const alert = useSelector(selectFormError);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <SpeedDial
        className="formError__speedDial"
        ariaLabel="FormError SpeedDial"
        icon={<ErrorOutlineIcon className="formError__speedDial__icon" />}
        onOpen={handleOpen}
        onClose={handleClose}
        hidden={!alert.open}
        open={open}
        direction="down"
        FabProps={{
          className: 'formError__speedDial__fab'
        }}
        style={{ zIndex: 3001 }}
      >
        {alert.errors?.map(error => (
          <SpeedDialAction key={error} icon={<ErrorIcon />} tooltipTitle={error} tooltipOpen />
        ))}
      </SpeedDial>
      {props.children}
    </>
  );
}
